import React from 'react';

interface FormRowProps {
  children: React.ReactNode;
  className?: string;
}

export const FormRow: React.FC<FormRowProps> = ({ children, className = '' }) => (
  <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-4 ${className}`}>
    {children}
  </div>
);

export const FormRowThree: React.FC<FormRowProps> = ({ children, className = '' }) => (
  <div className={`grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-4 ${className}`}>
    {children}
  </div>
);